import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { GenericFieldDirective } from '../../directives/generic-field/generic-field.directive';
import { FormSelect } from '../../interfaces/forms/form-element';
import { FormService } from '../../services/form/form.service';
import { FieldService } from './../../services/field/field.service';

@Component({
    selector: 'app-select-form',
    templateUrl: './select-form.component.html',
    styleUrls: ['./select-form.component.scss'],
    standalone: false
})
export class SelectFormComponent
  extends GenericFieldDirective
  implements OnInit, OnDestroy
{
  @Input() override field!: FormSelect;

  num = 0;
  constructor(
    private formService: FormService,
    protected override fieldService: FieldService,
    protected override element: ElementRef
  ) {
    super(fieldService, element);
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  onFilter(search: string, itemValue: string) {
    return search.length > 0
      ? itemValue.toLowerCase().indexOf(search.toLowerCase()) >= 0
      : true;
  }

  filterNull(_search: string, _itemValue: string) {
    return true;
  }

  onClose() {
    document.querySelectorAll('.nx-tooltip-panel').forEach((el) => {
      (<HTMLElement>el).style.top = '-99999px';
      (<HTMLElement>el).style.left = '-99999px';
    });
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
  }
}
